
import { defineComponent, ref } from 'vue'
import { useReflectiveInjector } from '@tanbo/vue-di-plugin'
import {
  OperateSystemService, SystemInfoRes
} from '@/views/dashboard/group/client/terminal-info/operate-system/operate-system.service'
import { formatTimeStamp } from '@/utils/time'

export default defineComponent({
  props: {
    deviceId: {
      type: String,
      default: ''
    }
  },

  setup (props, context) {
    const injector = useReflectiveInjector([OperateSystemService])
    const service = injector.get(OperateSystemService)

    const compData = ref({} as SystemInfoRes)
    const isLoading = ref(false)

    function updateData () {
      isLoading.value = true
      service.getSystemInfo({
        device_id: props.deviceId
      }).then(res => {
        compData.value = res
      }).finally(() => {
        isLoading.value = false
      })
    }

    updateData()

    return {
      compData,
      isLoading,
      formatTimeStamp,
    }
  }
})
